import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "gfu-field-select__content-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), _createSlots({
    default: _withCtx(() => [
      (_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            title: $props.placeholder,
            class: _normalizeClass([
                  'gfu-field__input gfu-field__input--faux gfu-field__input--readonly gfu-field__input--ellipsis',
                  { 'gfu-field__input--small': _ctx.small }
              ])
          }, _toDisplayString($props.placeholder), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['gfu-field-select', {'gfu-field-select--small': _ctx.small}])
          }, [
            _createVNode(_component_toggle_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_toggle_trigger, {
                  tag: "div",
                  tabindex: "0",
                  class: "gfu-field-select__trigger _tc--light",
                  "active-class": "gfu-field-select__trigger--active",
                  "data-qa": `select:${_ctx.name}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($props.placeholder), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["data-qa"]),
                _createVNode(_component_toggle_content, {
                  tag: "div",
                  tabindex: "1",
                  class: "gfu-field-select__content",
                  "active-class": "gfu-field-select__content--expanded",
                  onActiveChange: $options.onActiveChange,
                  "data-qa": "select-content"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "default")
                    ])
                  ]),
                  _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["onActiveChange"])
              ]),
              _: 3 /* FORWARDED */
            })
          ], 2 /* CLASS */))
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots.description)
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}